// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"20c104ca","332":"62be82c4"}[chunkId] + ".chunk.css";
};